import { actionTypes } from '../actions/streaks';
import { streaks as defaultState } from './default.json';

export const checkForFire = milestones => {
  return milestones > 0;
};

const handlers = {
  [actionTypes.STREAKS_GET_ERROR]: (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }),
  [actionTypes.STREAKS_GET_SUCCESS]: (state, action) => {
    const { results } = action || {};
    const { milestones } = results || {};
    const isOnFire = checkForFire(milestones);
    return { ...state, error: null, isOnFire, results };
  },
  [actionTypes.STREAKS_IS_LOADING]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [actionTypes.STREAKS_CREATE_ERROR]: (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }),
  [actionTypes.STREAKS_CREATE_SUCCESS]: (state, action) => ({
    ...state,
    didAchieveMilestone: true,
    error: null,
    isLoading: false,
    isOnFire: true,
    results: action.results,
  }),
  [actionTypes.STREAKS_REMOVE_ERROR]: (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }),
  [actionTypes.STREAKS_REMOVE_SUCCESS]: (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    isOnFire: false,
    results: action.results,
  }),
  [actionTypes.STREAKS_HIDE_MODAL]: state => ({
    ...state,
    error: null,
    isLoading: false,
    modal: null,
  }),
  [actionTypes.STREAKS_SHOW_MODAL]: (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    modal: action.modal,
  }),
  [actionTypes.STREAKS_UPDATE_ANALYTICS]: (state, { analytics }) => ({
    ...state,
    analytics,
  }),
  [actionTypes.STREAKS_MODAL_QUEUE]: (state, action) => ({
    ...state,
    shouldQueueStreaksModal: action.queStreaksModal,
  }),
  [actionTypes.STREAKS_SET_TEST_STATE]: (state, action) => {
    const { results } = action || {};
    const milestones =
      results.milestones !== undefined ? results.milestones : state.results.milestones;
    const durationForMilestone = action.duration ? action.duration : 420;
    return {
      ...state,
      durationForMilestone,
      isOnFire: checkForFire(milestones),
      error: null,
      isLoading: false,
      results: { ...state.results, ...results },
    };
  },
};

export default (state = defaultState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};
